/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import Header from "../header/Header";

import PostList from "../Data/PostList";
import sortedPosts from "../Data/Posts";
import Footer from "../Footer";

const Home = () => {
  const [activeFilter, setActiveFilter] = useState("all");
  const [slicedPosts, setSlicedPosts] = useState([]);
  const [sliceSize, setSliceSize] = useState(20);
  const [visibility, setVisibility] = useState(
    new Array(sortedPosts.length).fill(true)
  );
  const ref = useRef(null);

  // Slice post

  const updateSlicedPosts = () => {
    const slicedPosts = sortedPosts.slice(0, sliceSize);
    setSlicedPosts(slicedPosts);
  };

  const handleViewAll = () => {
    setSlicedPosts(sortedPosts);
    setVisibility(new Array(sortedPosts.length).fill(true));
  };

  useEffect(() => {
    updateSlicedPosts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleFilterClick = (event) => {
      const value = event.target.getAttribute("data-filter");
      setActiveFilter(value);

      if (value === "all") {
        setVisibility(new Array(sortedPosts.length).fill(true));
      } else {
        setVisibility(
          sortedPosts.map((post) => post.post_styles.includes(value))
        );
      }
    };

    document.querySelectorAll(".filter-item").forEach((element) => {
      element.addEventListener("click", handleFilterClick);
    });

    return () => {
      document.querySelectorAll(".filter-item").forEach((element) => {
        element.removeEventListener("click", handleFilterClick);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {/* Header */}
      <Header />

      {/* Home */}

      <section className="home" id="home">
        <div className="home-text container">
          <h2 className="home-title">
            Bee<span className="bee">Tech</span>
          </h2>
          <span className="home-subtitle">
            The ultimate provider of top-notch content
          </span>
        </div>
      </section>

      {/* <!-- Post Filter --> */}
      <div className="post-filter container">
        <span
          ref={ref}
          className={`filter-item ${
            activeFilter === "all" ? "active-filter" : ""
          }`}
          data-filter="all"
          onClick={() => setActiveFilter("all")}
        >
          All
        </span>
        <span
          className={`filter-item ${
            activeFilter === "tech" ? "active-filter" : ""
          }`}
          data-filter="tech"
          onClick={() => setActiveFilter("tech")}
        >
          Tech
        </span>
        <span
          className={`filter-item ${
            activeFilter === "design" ? "active-filter" : ""
          }`}
          data-filter="design"
          onClick={() => setActiveFilter("design")}
        >
          Design
        </span>
        <span
          className={`filter-item ${
            activeFilter === "developer" ? "active-filter" : ""
          }`}
          data-filter="developer"
          onClick={() => setActiveFilter("developer")}
        >
          Developer
        </span>
        <span
          className={`filter-item ${
            activeFilter === "marketing" ? "active-filter" : ""
          }`}
          data-filter="marketing"
          onClick={() => setActiveFilter("marketing")}
        >
          Marketing
        </span>
      </div>

      {/* <!-- Post Section --> */}
      <div className="container">
        <PostList posts={slicedPosts} visibility={visibility} />
        {sliceSize < sortedPosts.length && (
          <button onClick={handleViewAll} className="btn view-btn">
            View All
          </button>
        )}
      </div>

      <Footer />
    </>
  );
};

export default Home;
